document.addEventListener('DOMContentLoaded', function() {
            document.querySelectorAll('.accordion-map ').forEach(container => {
                container.querySelectorAll('.exp-item').forEach(item => {
                    // position the pegs on the map
                    let position = JSON.parse(item.dataset.position);
                    let peg = document.createElement('div');
                    peg.innerHTML = `
                        <div class="tooltip">
                            <span class="tooltip-title">${item.querySelector('.title').innerHTML}</span>
                            <span class="tooltip-tagline">${item.querySelector('.tagline').innerHTML}</span>
                        </div>`

                    peg.classList.add('peg');
                  
                  container.querySelectorAll('.peg').forEach(function(pegcb, i){
  					pegcb.id = "cb"+i;
					});
                    
                    peg.style.left = isNaN(position.x) ? position.x : position.x+'px';
                    peg.style.top = isNaN(position.y) ? position.y : position.y+'px';
                    container.querySelector('.map').appendChild(peg);

                    peg.addEventListener('click', () => {
                        container.querySelectorAll('.exp-item.active').forEach(item => {
                            item.classList.remove('active');
                        });
                        item.classList.add('active');
						
                  
                  		let elementPosition = item.getBoundingClientRect().top;
                        var offsetPosition = elementPosition + window.pageYOffset - 200;
						window['explicitscroll'] = true;
                        window.scrollTo({
                             top: offsetPosition,
                             behavior: "smooth"
                        });
		                  setTimeout(() => {
        					window['explicitscroll'] = false;
                           }, 1000)
                                     
                    });

                    item.querySelector('.header').addEventListener('click', () => {
                        container.querySelectorAll('.exp-item.active').forEach(item => {
                            item.classList.remove('active');
                        });
                        item.classList.add('active');
                    });
                });
            })
        });